export default __webpack_public_path__ + "static/OYOY-2160x438-30fps-cb966c622b52e256fb6602b9a582b402.mp4";